import { GlobalStyle } from "./globalStyles";
// import { lazy, Suspense } from "react";
import OurWorkDetails from "./Sections/OurWork/ourworkdetails";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// const Home = lazy(() => import("./Pages/Home"));
// const Header = lazy(() => import("./components/Header/index"));
// const Footer = lazy(() => import("./components/Footer/index"));
// const ScrollToTop = lazy(() => import("./components/ScrollToTop/index"));
import Home from "./Pages/Home";
import Header from "./components/Header/index";
import Footer from "./components/Footer/index";
import ScrollToTop from "./components/ScrollToTop/index";
import HorizontalMediaPanel from "./components/HorizontalMediaPanel";
function App() {
  return (
    <>
      <GlobalStyle />
      <Header />
      <HorizontalMediaPanel />
      <Router>
        <Switch>
          <Route exact path="/" component={Home}></Route>
        </Switch>
        <Switch>
          <Route exact path="/#home1" component={Home}></Route>
        </Switch>
        <Switch>
          <Route exact path="/#about1" component={Home}></Route>
        </Switch>
        <Switch>
          <Route exact path="/#services1" component={Home}></Route>
        </Switch>
        <Switch>
          <Route path="/ourWorkdetails1" component={OurWorkDetails}></Route>
        </Switch>
      </Router>
      <Footer />
    </>
  );
}

export default App;
